import React, { Component } from 'react';
import {
  Col, Row,
  Button,
  FormGroup,
  Label,
  Input,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import CompanyContext from '../../auth/CompanyContext';
class SaveSearchModal extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);

    this.available_dates = props.available_dates;

    this.state = {
      name: '',
      description: '',
      isLatest: false,
      isGlobal: false,
      showModal: false,
      isNew: false,
      current_date: this.props.current_date,
      previous_date: this.props.previous_date
      //previous_date: this.state.previous_date === undefined ? '' : this.state.previous_date
    };

  }

  parseKey = (key) => {
    let retStr = key.replace(/_/g, " ");
    retStr = retStr.replace(/([a-z])([A-Z])/g, "$1 $2");
    retStr = retStr.replace(/\s([a-z])/g, function ($0, $1) { return $0.replace($1, $1.toUpperCase()); });
    retStr = retStr.replace(/^([a-z])?/, function ($0, $1) { return $0.replace($1, $1.toUpperCase()); })
    return retStr;
  }

  modalOpen = (show, isNew) => {

    if (!isNew && "reportState" in this.props && this.props.reportState.ID > 0) {
      this.setState({
        name: this.props.reportState.Name,
        description: this.props.reportState.Description,
        isLatest: (this.props.reportState.Database == null),
        isGlobal: this.props.reportState._original.Global,
        showModal: show,
        isNew: isNew,
        current_date: this.props.current_date,
        previous_date: this.props.previous_date
      })
    } else {
      const initialSearchName = [];
      // Object.entries(this.props.group_selections).forEach(([key, value]) => {
      //   if (value !== '' && value !== null && value !== false) {
      //     initialSearchName.push(key + ': ' + value)
      //   }
      // });
      const params = this.props.group_selections;
      Object.keys(params).forEach(key => {
        if (key !== '' && params[key] !== '' && params[key] !== false && params[key] != null && params[key].length > 0) {
          initialSearchName.push(this.parseKey(key) + ": " + params[key])
        }
      });
      this.setState({
        name: initialSearchName.join(', '),
        description: '',
        isLatest: false,
        isGlobal: true,
        showModal: show,
        isNew: isNew,
      })
    }
  }


  handleModalSave = (e) => {

    const current_date = this.available_dates[this.state.current_date].date_key;
    const previous_date = this.props.previous_date !== '' ? this.available_dates[this.state.previous_date].date_key : '';
    const json_request = JSON.stringify({
      id: this.props.reportState.ID,
      name: this.state.name,
      description: this.state.description,
      parameters: JSON.stringify(this.props.group_selections),
      database: this.state.isLatest ? null : [current_date, previous_date].join('|'),
      global: this.state.isGlobal,
      type: this.props.type,
      auth0: this.props.user
    });
    fetch('/api/savedSearches/', {
      method: (this.state.isNew) ? 'POST' : 'PUT',
      body: json_request,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if ("callback" in this.props) this.props.callback();
      });

    this.setState({
      showModal: false,
    });
  }

  handleDelete = (e) => {
    this.setState(
      { isLoading: true }
    );
    fetch('/api/savedSearches/' + this.props.reportState.ID, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (results.debug_message.error === null) {
          if ("callback" in this.props) this.props.callback();
          this.modalOpen(false);
        }
      });
  }

  handleTextInputChange = (e) => {
    e.persist();

    this.setState(prevState => {
      const sel = prevState;
      sel[e.target.name] = e.target.value;
      return { sel }
    });
  }

  handleBooleanInputChange = (e) => {
    e.persist();
    this.setState(prevState => {
      const sel = prevState;
      sel[e.target.name] = e.target.checked;
      return { sel }
    });
  }

  handleDateInputChange = (e) => {
    e.persist();

    if (e.target.name === 'current_date') {
      var new_current = this.available_dates.findIndex(d => e.target.value === d.date_string);
      new_current = Math.min(Math.max(new_current, 0), this.available_dates.length - 1);
      this.setState({
        current_date: new_current
      });
    }
  }

  render() {
    return (
      <Modal isOpen={this.state.showModal}>
        <ModalHeader >
          Save Search
          </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Saved Search Name</Label>
            <Input
              type="text"
              name="name"
              onChange={e => this.handleTextInputChange(e)}
              value={this.state.name}
            />
          </FormGroup>
          <FormGroup>
            <Label>Description</Label>
            <Input
              type="textarea"
              name="description"
              onChange={e => this.handleTextInputChange(e)}
              value={this.state.description}
            />
          </FormGroup>
          <Row>

            <Col>
              <FormGroup>
                <Label>Database</Label>
                <Input
                  type="select"
                  name="current_date"
                  onChange={e => this.handleDateInputChange(e)}
                  disabled={this.state.isLatest}
                  value={this.available_dates[this.state.current_date].date_string}
                >
                  <option key='current_date_1000000'>Latest</option>
                  {this.available_dates.map(d => (
                    <option key={'current_date_' + d.date_string}>{d.date_string}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col>
              <Row>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      name="isLatest"
                      onChange={e => this.handleBooleanInputChange(e)}
                      checked={this.state.isLatest}
                    /> Or Use Latest
                        </Label>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      name="isGlobal"
                      onChange={e => this.handleBooleanInputChange(e)}
                      checked={this.state.isGlobal}
                    /> Save for All Users
                        </Label>
                </FormGroup>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          {(this.props.reportState.ID > -1) ?
            <Button color="danger" onClick={() => this.handleDelete()}>
              Delete
              </Button> : <></>}
          <Button color="secondary" onClick={() => this.modalOpen(false)}>
            Cancel
              </Button>
          <Button color="primary" onClick={this.handleModalSave} disabled={this.state.name === ''}>
            Save
              </Button>
        </ModalFooter>
      </Modal>
    )
  }

}

export default SaveSearchModal;